module.exports = __webpack_public_path__ + "img/copy-icon.a2deb888.svg";